/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'ai-mate.chat-error-banner.description': '您的聊天記錄最多可儲存 30 天。',
  'ai-mate.chat-error-banner.title': '開始新聊天',
  'ai-mate.chat-error.description': '嘗試<btn>重新載入聊天</btn>。',
  'ai-mate.chat-error.rate-limited-description': '您已達到要求的數量上限。請稍後再試一次。',
  'ai-mate.chat-error.rate-limited-title': '要求過多',
  'ai-mate.chat-error.rovo-inactive-description': '您的網站似乎並未啟用 Rovo。<link>設定 Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo 處於非作用中的狀態',
  'ai-mate.chat-error.title': '我們不確定發生了什麼問題',
  'ai-mate.chat-input.file-close-icon-label': '移除檔案',
  'ai-mate.chat-input.file-error-icon-label': '載入檔案時發生錯誤',
  'ai-mate.chat-view.chat-item.chat-delete-label': '刪除',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label': '{conversationName} 的聊天選項',
  'ai-mate.chat-view.chat-item.chat-rename-label': '重新命名',
  'ai-mate.common.ui.expandable-section.collapse': '摺疊',
  'ai-mate.common.ui.expandable-section.expand': '展開',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': '取消',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    '您嘗試刪除的對話不存在。',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': '刪除',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    '要刪除對話「{name}」嗎？',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    '刪除對話時發生錯誤。請再試一次。',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    '您確定要刪除此對話嗎？此動作無法復原。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': '取消',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    '您嘗試編輯的頻道不存在。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': '名稱',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    '編輯對話時發生錯誤。請再試一次。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': '編輯對話',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    '此名稱與目前的名稱相同。',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': '儲存',
  'ai-mate.conversation-list-view.accessible-search-results': '{results, plural, other {找到 {results,number} 個結果}}',
  'ai-mate.conversation-list-view.back-button.label': '返回',
  'ai-mate.conversation-list-view.close-chat-button.label': '關閉聊天',
  'ai-mate.conversation-list-view.header-title': '聊天記錄',
  'ai-mate.conversation-list-view.new-chat-button.label': '新的聊天',
  'ai-mate.conversation-list-view.no-chat': '沒有結果',
  'ai-mate.conversation-list-view.search-input.placeholder': '搜尋聊天',
  'ai-mate.expander.hide-details': '隱藏詳細資料',
  'ai-mate.expander.show-details': '顯示較多詳細資料',
  'ai-mate.main-chat.close-chat-panel-button-label': '關閉聊天',
  'ai-mate.main-chat.maximize-chat-button-label': '全螢幕',
  'ai-mate.main-chat.minimize-chat-button-label': '復原檢視',
  'ai-mate.main-chat.new-chat-button-label': '新增',
  'ai-mate.main-chat.new-chat-button-label-full-screen': '新的聊天',
  'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': '傳送',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': '向 AI 詢問',
  'highlight-actions.rovo-chat-explain-option.text': '說明',
  'highlight-actions.rovo-chat-explain-prompt':
    '藉由換個方式描述並且新增額外的細節來說明，但是請使用簡單的語言、簡短的句子，並且針對原始描述中所使用的專有名詞提供範例或定義。',
  'highlight-actions.rovo-chat-find-resources-option.text': '尋找資源',
  'highlight-actions.rovo-chat-find-resources-prompt': '在組織知識內，尋找僅支援所作陳述的資源。',
  'highlight-actions.rovo-chat-give-examples-option.text': '提供範例',
  'highlight-actions.rovo-chat-give-examples-prompt':
    '從組織資源或公開知識中提供相關例子。如果沒有可提供的資源，請嘗試提供比喻的例子，協助他人進一步了解。',
  'highlight-actions.rovo-chat-give-feedback-option.text': '提供意見反應',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    '透過檢閱描述方式來提供意見反應。針對字詞的選擇、文法和標點符號提供看法。保持積極正面，但一律提供至少一項需要改善或變更的地方。',
  'highlight-actions.rovo-chat-more-options.tooltip': '聊天建議',
  'highlight-actions.rovo-chat-open-chat.tooltip': '開啟聊天',
  'highlight-actions.rovo-chat-summarize-option.text': '總結',
  'highlight-actions.rovo-chat-summarize-prompt':
    '凸顯其中的重點。專注於重要資訊並排除不必要的細節。在單一段落中提供簡潔的概述。',
  'highlight-actions.rovo-chat.button-text': '聊天',
  'highlight-actions.rovo-chat.button-text-ask-in-chat': '在聊天中詢問',
  'highlight-actions.rovo-chat.placeholder-prompt': '詢問相關問題。',
  'horizontal-scroll-container.scroll-left': '向左捲動',
  'horizontal-scroll-container.scroll-right': '向右捲動',
  'rovo-chat.deep-research-spotlight.description':
    '開啟深入研究並輸入提示。Rovo 將建立一個計畫、進行研究，並製作完整的報告。',
  'rovo-chat.deep-research-spotlight.dismiss': '關閉',
  'rovo-chat.file-upload-dropzone.drag-drop-message': '拖放以新增背景資訊',
  'rovo-chat.message-file.icon-label': '檔案',
};
